<template>
  <div class="row">
    <div class="col-md-12">
      <div class="card">
        <div class="card-body">
          <h5 class="card-title">{{ receipt.enterprise_name }}</h5>

          <div class="card mt-5">
            <div class="card-header">
              Información básica
            </div>
            <div class="card-body">
              <div class="row">
                <div class="col-md-2">
                  <h6>Estatus</h6>
                </div>
                <div class="col-md-2 right">
                  <h6 v-if="receipt.paid_date">Pagado</h6>
                  <h6 v-else>Creado</h6>
                </div>
                <div class="col-md-2 right">
                  <h6>Monto</h6>
                </div>
                <div class="col-md-2 right">
                  <h6>Comisión</h6>
                </div>
                <div class="col-md-2 right">
                  <h6>IVA</h6>
                </div>
                <div class="col-md-2 right">
                  <h6>Total</h6>
                </div>
              </div>
              <div class="row">
                <div class="col-md-2">
                  {{ receipt.status_name }}
                </div>
                <div class="col-md-2 right">
                  <span v-if="receipt.paid_date">{{ receipt.paid_date }}</span>
                  <span v-else>{{ receipt.creation_date }}</span>
                </div>
                <div class="col-md-2 right">$ {{ receipt.amount | formatNumberCurrency }}</div>
                <div class="col-md-2 right">$ {{ receipt.fee_amount | formatNumberCurrency }}</div>
                <div class="col-md-2 right">$ {{ receipt.iva | formatNumberCurrency }}</div>
                <div class="col-md-2 right">
                  <strong>$ {{ receipt.total | formatNumberCurrency }}</strong>
                </div>
              </div>
            </div>
          </div>

          <div class="card mt-3">
            <div class="card-header">
              Detalles del pago
            </div>
            <div class="card-body" v-if="receipt.receipt_status_id === 1">
              <b-form inline @submit.stop.prevent="onSubmit">
                <label class="sr-only" for="inline-form-input-invoice">Factura</label>
                <b-form-input
                  id="inline-form-input-invoice"
                  class="mb-2 mr-sm-2 mb-sm-0"
                  placeholder="Factura"
                  type="text"
                  v-model="$v.form.invoice.$model"
                  :state="validateState('invoice')"
                ></b-form-input>

                <label class="sr-only" for="inline-form-input-date">Fecha Pago</label>
                <b-form-input
                  id="inline-form-input-date"
                  class="mb-2 mr-sm-2 mb-sm-0"
                  type="date"
                  v-model="$v.form.paymentDay.$model"
                  :state="validateState('paymentDay')"
                ></b-form-input>

                <label class="sr-only" for="inline-form-input-reference">Referencia</label>
                <b-form-input
                  id="inline-form-input-reference"
                  class="mb-2 mr-sm-2 mb-sm-0"
                  placeholder="Referencia"
                  type="text"
                  v-model="$v.form.reference.$model"
                  :state="validateState('reference')"
                ></b-form-input>

                <label class="mr-sm-2" for="inline-form-custom-select-pref">Tipo Referencia</label>
                <b-form-select
                  id="inline-form-custom-select-pref"
                  class="mb-2 mr-sm-2 mb-sm-0"
                  :options="referenceTypeOptions"
                  :value="null"
                  v-model="$v.form.referenceType.$model"
                  :state="validateState('referenceType')"
                ></b-form-select>

                <b-button type="submit" variant="primary">Agregar Pago</b-button>
              </b-form>
            </div>
            <div class="card-body" v-else>
              <div class="row">
                <div class="col-md-4 center">
                  <h6>Factura</h6>
                </div>
                <div class="col-md-4 center">
                  <h6>Referencia</h6>
                </div>
                <div class="col-md-4 center">
                  <h6>Tipo Referencia</h6>
                </div>
              </div>
              <div class="row">
                <div class="col-md-4 center">{{ receipt.invoice }}</div>
                <div class="col-md-4 center">{{ receipt.reference }}</div>
                <div class="col-md-4 center">{{ receipt.reference_type }}</div>
              </div>
            </div>
          </div>

          <div class="mt-5">
              <vue-good-table
                mode="remote"
                :columns="columns"
                :rows="rows"
                :totalRows="totalRecords"
                :sort-options="{
                  enabled: true,
                }"
                :isLoading.sync="isLoading"
                styleClass="vgt-table bordered"
                :pagination-options="{
                  enabled: true,
                  mode: 'registros',
                  position: 'top',
                  perPage: 10,
                  nextLabel: 'siguiente',
                  prevLabel: 'anterior',
                  rowsPerPageLabel: 'Filas por página',
                  ofLabel: 'de',
                  pageLabel: 'páginas', // for 'pages' mode
                  allLabel: 'Todos',
                }"
                @on-page-change="onPageChange"
                @on-sort-change="onSortChange"
                @on-column-filter="onColumnFilter"
                @on-per-page-change="onPerPageChange"
                @on-row-click="onRowClick"
              >
                <template slot="table-row" slot-scope="props">
                  <span v-if="props.column.field == 'final_amount'">
                    <span>$ {{ props.row.final_amount | formatNumberCurrency }}</span>
                  </span>
                  <span v-else-if="props.column.field == 'fee_amount'">
                    <span>$ {{ props.row.fee_amount | formatNumberCurrency }}</span>
                  </span>
                  <span v-else-if="props.column.field == 'iva'">
                    <span>$ {{ props.row.iva | formatNumberCurrency }}</span>
                  </span>
                  <span v-else-if="props.column.field == 'total'">
                    <span>$ {{ props.row.total | formatNumberCurrency }}</span>
                  </span>
                  <span v-else>
                    {{props.formattedRow[props.column.field]}}
                  </span>
                </template>
              </vue-good-table>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  BForm,
  BFormInput,
  BButton,
  BFormSelect
} from 'bootstrap-vue'
import axiosAdelaService from '@/axios/axiosAdelaService'
import { validationMixin } from 'vuelidate'
import { required } from 'vuelidate/lib/validators'
import { VueGoodTable } from 'vue-good-table'

export default {
  mixins: [validationMixin],
  components: {
    BForm,
    BFormInput,
    BButton,
    BFormSelect,
    VueGoodTable
  },
  data () {
    return {
      receipt: null,
      referenceTypeOptions: null,
      form: {
        invoice: null,
        paymentDay: null,
        reference: null,
        referenceType: null
      },
      rows: [],
      isLoading: false,
      totalRecords: 0,
      serverParams: {
        columnFilters: {},
        sort: {
          field: '',
          type: ''
        },
        page: 1,
        perPage: 10
      },
      columns: [
        {
          label: 'No. empleado',
          field: 'enterprise_user_number',
          width: '100px',
          filterOptions: {
            enabled: false
          }
        },
        {
          label: 'Nombre',
          field: 'full_name',
          filterOptions: {
            enabled: false
          }
        },
        {
          label: 'Fecha de solicitud',
          field: 'request_date',
          width: '100px',
          filterOptions: {
            enabled: false
          }
        },
        {
          label: 'Monto Otorgado',
          field: 'final_amount',
          // width: '100px',
          type: 'number',
          filterOptions: {
            enabled: false
          }
        },
        {
          label: 'Comisión',
          field: 'fee_amount',
          // width: '100px',
          type: 'number',
          filterOptions: {
            enabled: false
          }
        },
        {
          label: 'IVA',
          field: 'iva',
          // width: '100px',
          type: 'number',
          filterOptions: {
            enabled: false
          }
        },
        {
          label: 'Monto Final',
          field: 'total',
          // width: '120px',
          type: 'number',
          filterOptions: {
            enabled: false
          }
        }
      ]
    }
  },
  validations: {
    form: {
      invoice: {
        required
      },
      paymentDay: {
        required
      },
      reference: {
        required
      },
      referenceType: {
        required
      }
    }
  },
  methods: {
    validateState (name) {
      const { $dirty, $error } = this.$v.form[name]
      return $dirty ? !$error : null
    },
    async onSubmit () {
      try {
        this.$v.form.$touch()
        if (this.$v.form.$anyError) {
          return
        }
        const response = await axiosAdelaService.post('/addReceiptPayment', JSON.stringify({
          receiptId: this.receipt.receipt_id,
          ...this.form
        }))
        if (response.data.success) {
          this.$toastedPush({
            message: response.data.msg,
            type: 'success'
          })
          this.$router.push({ name: 'receipts' })
        }
      } catch (error) {
        this.showError('No se pudo registrar el pago intentalo mas tarde.')
      }
    },
    updateParams (newProps) {
      this.serverParams = Object.assign({ page: 0 }, this.serverParams, newProps)
    },
    onRowClick (params) {
      this.$router.push({ name: 'receiptsProcess', params: params })
    },
    onPageChange (params) {
      this.updateParams({ page: params.currentPage })
      this.loadItems()
    },
    onPerPageChange (params) {
      this.updateParams({ perPage: params.currentPerPage })
      this.loadItems()
    },
    onSortChange (params) {
      console.log(params)
      this.updateParams({
        sort: {
          type: params[0].type,
          field: params[0].field
        }
      })
      this.loadItems()
    },
    onColumnFilter (params) {
      this.updateParams(params)
      this.loadItems()
    },
    async loadItems (first = false) {
      try {
        const response = await axiosAdelaService.post('/getReceiptDetails', JSON.stringify({
          first: first,
          receiptId: this.receipt.receipt_id,
          ...this.serverParams
        }))
        if (response.status === 200) {
          this.totalRecords = response.data.totalRecords
          this.rows = response.data.rows
        }
      } catch (error) {
        this.showError('No se pudieron obtener el detalle del recibo intentalo mas tarde.')
      }
    },
    async loadReferenceTypes () {
      try {
        const referenceTypeResponse = await axiosAdelaService.post('/referensetypeselect', JSON.stringify({}))
        if (referenceTypeResponse.status === 200) {
          this.referenceTypeOptions = this.$_.map(referenceTypeResponse.data, (type) => {
            return {
              value: type.receipt_reference_type_id,
              text: type.reference_type
            }
          })
        }
      } catch (error) {
        this.showError('No se pudieron obtener los datos intentalo mas tarde.')
      }
    }
  },
  mounted () {
    this.loadItems(true)
    if (this.$_.isEmpty(this.receipt.paid_date)) {
      this.loadReferenceTypes()
    }
  },
  created () {
    this.receipt = this.$_.get(this.$route, 'params.row', {})
  }
}
</script>

<style>

</style>
